const triggers = document.querySelectorAll("[data-footer-modal-trigger]");
const dialogs = document.querySelectorAll("dialog[data-footer-modal]");

triggers.forEach((trigger) => {
  const id = trigger.dataset.footerModalTrigger;
  const dialog = document.querySelector(`dialog[data-footer-modal="${id}"]`);
  if (!dialog) return;

  trigger.addEventListener("click", () => {
    if (dialog.open) return;
    dialog._triggerElement = trigger;
    dialog.classList.remove("is-closing");
    dialog.showModal();
    dialog.classList.add("flex");
    dialog.querySelector("[data-footer-modal-close]")?.focus();
  });
});

dialogs.forEach((dialog) => {
  const closeBtn = dialog.querySelector("[data-footer-modal-close]");

  closeBtn?.addEventListener("click", () => close(dialog));

  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) close(dialog);
  });

  // Route native Escape key through close() so the exit animation plays
  dialog.addEventListener("cancel", (e) => {
    e.preventDefault();
    close(dialog);
  });
});

function close(dialog) {
  if (!dialog.open || dialog.classList.contains("is-closing")) return;
  dialog.classList.add("is-closing");
  const onEnd = (e) => {
    if (e.animationName !== "footer-dialog-exit") return;
    dialog.removeEventListener("animationend", onEnd);
    dialog.classList.remove("is-closing", "flex");
    dialog.close();
    dialog._triggerElement?.focus();
  };
  dialog.addEventListener("animationend", onEnd);
}
